import { Reveal } from "./Reveal";

const celebs = [
  { name: "Mika Singh", role: "Singer & Performer", img: "/images/celeb-mika.webp", pos: "object-[50%_25%]" },
  { name: "Jaya Prada", role: "Actor & Politician", img: "/images/celeb-jaya.webp", pos: "object-[65%_30%]" },
  { name: "Taapsee Pannu", role: "Actor", img: "/images/celeb-taapsee.jpeg", pos: "object-[40%_30%]" },
  { name: "Mallika Sherawat", role: "Actor", img: "/images/celeb-mallika.webp", pos: "object-[60%_25%]" },
  { name: "Disha Parmar", role: "Actor", img: "/images/celeb-disha.webp", pos: "object-[55%_25%]" },
  { name: "Anushka Sen", role: "Actor", img: "/images/celeb-anushka.webp", pos: "object-[55%_25%]" },
  { name: "Ahsaas Channa", role: "Actor", img: "/images/celeb-ahsaas.webp", pos: "object-[55%_25%]" },
  { name: "Kanika Mann", role: "Actor", img: "/images/celeb-kanika.webp", pos: "object-[55%_25%]" },
];

export const CelebritySmiles = () => (
  <section id="celebrities" className="py-16 lg:py-24 bg-[#FAFAF8]" data-testid="celebrities-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="max-w-3xl">
        <span className="font-heading text-xs sm:text-sm font-bold tracking-[0.25em] uppercase text-[#8A7440]">Celebrity Smiles</span>
        <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-4 leading-[1.12] text-[#0E0E0E]">
          Trusted by the <em className="font-bold text-[#C6A45C]">stars</em>.
        </h2>
        <p className="mt-5 text-base lg:text-lg text-[#57534E] leading-relaxed">
          From Bollywood icons to music legends, India's best-known faces trust Dr. Kshama with their smiles.
        </p>
      </Reveal>
      <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {celebs.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.1} className="course-card group relative rounded-2xl overflow-hidden" data-testid={`celebrity-card-${c.name.toLowerCase().replace(/ /g, "-")}`}>
            <div className="course-img-wrap h-72 sm:h-80 lg:h-96">
              <img src={c.img} alt={`${c.name} with Dr. Kshama Chandan`} className={`w-full h-full object-cover ${c.pos}`} loading="lazy" />
            </div>
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0E0E0E]/90 via-[#0E0E0E]/40 to-transparent pt-16 pb-4 px-4">
              <p className="font-heading font-bold text-white text-base lg:text-lg leading-tight">{c.name}</p>
              <p className="font-heading text-[11px] font-semibold tracking-[0.12em] uppercase text-[#E7CE96] mt-1">{c.role}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
